module.exports = __webpack_public_path__ + "be3adc94190526bf62db9805fa6931bc.png";